export default {
  // 获取当前url的参数
  GetRequest(url) {
    if (typeof (url) === 'undefined') url = location.href;
    const theRequest = new Object();
    if (url.indexOf('?') != -1) {
      const str = url.substr((url.indexOf('?') + 1)); const strs = str.split('&');
      for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
      }
    }
    return theRequest;
  },
};
